import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { viewerApi, errMsg } from "@/lib/api";
import { Logo } from "@/components/Layout";

export default function Join() {
  const { token } = useParams();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const join = async (body) => {
    setBusy(true); setErr("");
    try {
      const { data } = await viewerApi.post("/viewer/join", body);
      localStorage.setItem("tpc_viewer", data.token);
      nav("/view", { replace: true });
    } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  useEffect(() => { if (token) join({ token }); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#070D18] text-white flex flex-col items-center justify-center px-5">
      <div className="w-full max-w-sm tpc-rise">
        <Logo />
        <h1 className="h1 mt-8">Join your team</h1>
        <p className="text-slate-400 mt-2">Ask your coach for the team code. You'll see the team's plays. No account needed.</p>
        {token && busy && <p className="mt-6 text-slate-300" data-testid="join-loading">Opening your team playbook…</p>}
        <form onSubmit={(e) => { e.preventDefault(); join({ code }); }} className="mt-8 space-y-4" data-testid="join-form">
          <label className="label" htmlFor="code">Team code</label>
          <input id="code" className="input text-2xl font-mono tracking-[0.2em] uppercase text-center" maxLength={9} placeholder="ABCD-1234" value={code} onChange={(e) => setCode(e.target.value)} autoComplete="off" data-testid="join-code-input" />
          {err && <p className="text-red-300 text-sm" role="alert" data-testid="join-error">{err}</p>}
          <button className="btn btn-primary w-full text-base" disabled={busy || code.replace(/[^a-z0-9]/gi, "").length < 8} data-testid="join-submit-button"><KeyRound size={18} />Open playbook</button>
        </form>
        <p className="mt-6 text-sm text-slate-400">Are you a coach? <Link to="/login" className="text-[#FF8A1F] font-bold" data-testid="join-coach-link">Sign in</Link></p>
      </div>
    </div>
  );
}
